import Dropzone from 'react-dropzone';
import { Link } from 'gatsby';

import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import ButtonLink from '../components/ui/ButtonLink';

import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';
import { colors } from '../styles/colors';
//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

const PageTemplate = css`
.site-main {
background #fff;
padding-bottom: 4vw;
}

.post-content {
max-width: 1000px;
margin: -2.5rem auto 0;
}
.post-full-content {
  background: transparent;
}
p {
  font-size: 2rem !important;

}
h2 {
  margin-top: 0;
  font-size: 3rem;

  small {
    font-size: 1.5rem;
    font-weight: normal;
  }
}
h2::before {
all: unset !important;
}
h3 {
text-decoration: none !important;
padding-top: 5rem;
text-align: center;
}
`;

const FactsBox = styled.div`
  margin-top: 1.5rem;
  background: #EFFAF2;
  padding: 1.3rem 1.3rem 0.45rem;

  @media (max-width: 750px) {
    padding: 0.1rem 0.1rem 0.1rem;
  }

  li:first-letter {
    color: #ACE3BA;
  }

  h3 {
    padding-top: 0;
  }
`;

const DropZoneDiv = styled.div`
cursor: pointer;
border: 2px dashed  ${colors.beta};
background: repeating-linear-gradient(
  45deg,
  transparent,
  transparent 35px,
  ${colors.beta} 0,
  ${colors.beta} 70px
);
  max-width: 600px;
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  p {
    margin-bottom: 0;
    font-weight: bold;
  }
`;

const Logo = styled.div`
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin: 0 auto 2rem;
  background: linear-gradient(90deg, #060f54 50%, #f60065 50%);
  box-shadow: rgba(39, 44, 49, 0.08) 0px 0px 28px, rgba(39, 44, 49, 0.06) 1px 3px 8px;

  transform: rotate(-45deg);

  :hover {
    animation: logo-anim 2.5s linear infinite;
  }

  @keyframes logo-anim {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const WrapThumbnails = styled.div`
  display: flex;
  margin: 3rem 0 2rem;
  padding: 0 0 3.2rem;
  overflow-x: scroll;
  scrollbar-color: #D7F2DE #f2eaf8;
  scrollbar-width: auto;
  position: relative;

  -webkit-mask-image: linear-gradient(
    to left,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );
  mask-image: linear-gradient(to left, transparent 0%, black 10%, black 90%, transparent 100%);

  img {
    object-fit: cover;
    width: 100px;
    height: 100px;
    min-width: 100px;
    max-width: 100px;
    border-radius: 50%;
    cursor: pointer;
    margin: 0 0.35rem;

    transition: box-shadow 0.35s ease-out;
  }
  img.active {
    border: 3px solid;
    box-shadow: rgba(39, 44, 49, 0.14) 4px 14px 25px, rgba(39, 44, 49, 0.08) 1px 3px 6px;
  }
  img:hover {
    // transform: translateY(-0.25rem);
    box-shadow: rgba(39, 44, 49, 0.14) 4px 14px 25px, rgba(39, 44, 49, 0.08) 1px 3px 6px;
  }
`;

interface ResultImgProps {
  activeFilter: number;
}

const ResultImg = styled.img<ResultImgProps>`
  max-height: 800px;
  object-fit: cover;

  filter: url(#filter-${props => props.activeFilter});

  :active {
    filter: none;
  }
`;

const ThumbImg1 = styled.img`
  filter: url(#filter-1);
`;
const ThumbImg2 = styled.img`
  filter: url(#filter-2);
`;
const ThumbImg3 = styled.img`
  filter: url(#filter-3);
`;

const ThumbImg4 = styled.img`
  filter: url(#filter-4);
`;
const ThumbImg5 = styled.img`
  filter: url(#filter-5);
`;
const ThumbImg6 = styled.img`
  filter: url(#filter-6);
`;
const ThumbImg7 = styled.img`
  filter: url(#filter-7);
`;
const ThumbImg8 = styled.img`
  filter: url(#filter-8);
`;
const ThumbImg9 = styled.img`
  filter: url(#filter-9);
`;
const ThumbImg10 = styled.img`
  filter: url(#filter-10);
`;
const ThumbImg11 = styled.img`
  filter: url(#filter-11);
`;
const ThumbImg12 = styled.img`
  filter: url(#filter-12);
`;
const ThumbImg13 = styled.img`
  filter: url(#filter-13);
`;
const ThumbImg14 = styled.img`
  filter: url(#filter-14);
`;
const ThumbImg15 = styled.img`
  filter: url(#filter-15);
`;
const ThumbImg16 = styled.img`
  filter: url(#filter-16);
`;

interface DuotoneGeneratorState {
  hasCustomImage: boolean;
  photoData: any;
  active: number;
  downloadUrl: string;
}

class DuotoneGenerator extends React.Component<undefined, DuotoneGeneratorState> {
  state = {
    hasCustomImage: false,
    photoData: undefined,
    active: 1,
    downloadUrl: '',
  };

  exampleUrl = '/guide/images/duotone-generator/example/duotone-example.jpg';
  photoRef;
  canvasRef;

  constructor(props) {
    super(props);
    this.photoRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  setActive = (filterNb: number) => {
    this.setState({ active: filterNb });

    setTimeout(() => {
      const downloadUrl = this.downloadPhoto();
      this.setState({ downloadUrl });
    }, 0);
  };

  onDrop = file => {
    const reader = new FileReader();

    // reader.onabort = () => console.log('file reading was aborted');
    // reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      this.setState({ photoData: reader.result });

      setTimeout(() => {
        const downloadUrl = this.downloadPhoto();
        this.setState({ downloadUrl });
      }, 0);
    };

    reader.readAsDataURL(file[0]);
  };

  downloadPhoto = () => {
    const canvas = this.canvasRef.current;
    const photo = this.photoRef.current;
    const { naturalWidth, naturalHeight } = photo;

    canvas.width = naturalWidth;
    canvas.height = naturalHeight;
    photo.style.maxWidth = 'none';
    photo.style.maxHeight = 'none';
    photo.style.width = naturalWidth;
    photo.style.height = naturalHeight;

    const ctx = canvas.getContext('2d');
    ctx.filter = `url(#filter-${this.state.active})`;
    ctx.drawImage(photo, 0, 0, photo.width, photo.height);

    photo.style.maxWidth = '100%';
    photo.style.maxHeight = '800px';

    return canvas.toDataURL('image/jpeg');
  };

  render() {
    return (
      <IndexLayout>
        <Helmet>
          <title>Duotone Generator and Previewer with Photoshop Actions | Giggster Guide</title>
          <meta
            name="description"
            content="Here's a simple online tool to preview different duotone color options on your images and then quickly apply them in Photoshop using a free action."
          />

          <meta property="og:site_name" content="Giggster Guide" />
          <meta property="og:type" content="article" />
          <meta
            property="og:title"
            content="Duotone Generator and Previewer with Photoshop Actions"
          />
          <meta
            property="og:description"
            content="Here's a simple online tool to preview different duotone color options on your images and then quickly apply them in Photoshop using a free action."
          />
          <meta property="og:url" content="https://giggster.com/guide/duotone-generator/" />
          <meta property="og:image" content="https://giggster.com/guide/covers/duotone-generator.jpg" />
          <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Duotone Generator and Previewer with Photoshop Actions"
          />
          <meta
            name="twitter:description"
            content="Here's a simple online tool to preview different duotone color options on your images and then quickly apply them in Photoshop using a free action."
          />
          <meta name="twitter:url" content="https://giggster.com/guide/duotone-generator/" />
          <meta name="twitter:image" content="https://giggster.com/guide/covers/duotone-generator.jpg" />
          <meta name="twitter:site" content="@Giggster" />
          <meta name="twitter:creator" content="@Giggster" />
        </Helmet>
        <Wrapper css={PageTemplate}>
          <header css={[outer, SiteHeader]}>
            <div css={inner}>
              <SiteNav />
            </div>
          </header>
          <main id="site-main" className="site-main" css={[SiteMain, outer]}>
            <article className="post page" css={[PostFull, NoImage]}>
              <PostFullHeader>
                <PostFullTitle>
                  <Logo />
                  Duotone Generator and Previewer with Free Photoshop Actions
                </PostFullTitle>
                <p className="t2">
                  Quickly preview different duotone color combinations to apply to your photos in
                  Photoshop. <a href="#how-it-works">Learn how it works here</a>.
                </p>
                {/*<ShareButtons
                  title={'Duotone Generator'}
                  slug={'/duotone-generator/'}
                  imgSrc={'covers/duotone-generator.jpg'}
                />*/}
              </PostFullHeader>

              <PostFullContent className="post-full-content">
                <div className="post-content text-center">
                  <h2 className="text-center">Upload Your Image</h2>

                  <Dropzone multiple={false} accept="image/jpeg, image/png" onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <DropZoneDiv {...getRootProps()}>
                          <input {...getInputProps()} />
                          <p>Drag a photo here, or click to select one</p>
                        </DropZoneDiv>
                      </section>
                    )}
                  </Dropzone>

                  <hr />

                  <WrapThumbnails>
                    <ThumbImg1
                      className={this.state.active === 1 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(1)}
                    />
                    <ThumbImg2
                      className={this.state.active === 2 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(2)}
                    />
                    <ThumbImg3
                      className={this.state.active === 3 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(3)}
                    />
                    <ThumbImg4
                      className={this.state.active === 4 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(4)}
                    />
                    <ThumbImg5
                      className={this.state.active === 5 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(5)}
                    />
                    <ThumbImg6
                      className={this.state.active === 6 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(6)}
                    />
                    <ThumbImg7
                      className={this.state.active === 7 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(7)}
                    />
                    <ThumbImg8
                      className={this.state.active === 8 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(8)}
                    />
                    <ThumbImg9
                      className={this.state.active === 9 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(9)}
                    />

                    <ThumbImg10
                      className={this.state.active === 10 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(10)}
                    />
                    <ThumbImg11
                      className={this.state.active === 11 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(11)}
                    />

                    <ThumbImg12
                      className={this.state.active === 12 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(12)}
                    />
                    <ThumbImg13
                      className={this.state.active === 13 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(13)}
                    />
                    <ThumbImg14
                      className={this.state.active === 14 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(14)}
                    />

                    <ThumbImg15
                      className={this.state.active === 15 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(15)}
                    />

                    <ThumbImg16
                      className={this.state.active === 16 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(16)}
                    />
                  </WrapThumbnails>

                  {this.state.photoData ? (
                    <ResultImg
                      activeFilter={this.state.active}
                      src={this.state.photoData}
                      // tslint:disable-next-line
                      onTouchStart={() => {}}
                      ref={this.photoRef}
                    />
                  ) : (
                    <ResultImg
                      activeFilter={this.state.active}
                      src={this.exampleUrl}
                      ref={this.photoRef}
                      // tslint:disable-next-line
                      onTouchStart={() => {}}
                    />
                  )}
                  <h2 className="text-center">
                    Duotone #{this.state.active} <br />
                    <small>(tap/click on image to view original)</small>
                  </h2>

                  <p>
                    <ButtonLink
                      href="https://purple11.s3.amazonaws.com/actions/purple11-duotones.zip"
                      download="purple11-duotones.atn"
                    >
                      Download Photoshop Actions
                    </ButtonLink>{' '}
                    {this.state.downloadUrl ? (
                      <>
                        <ButtonLink
                          href={this.state.downloadUrl}
                          download={`duotone-${this.state.active}.jpg`}
                        >
                          Download Photo
                        </ButtonLink>
                        <br />
                        <small>
                          Note that downloading the photo directly only works in Chrome or Firefox
                          for now
                        </small>
                      </>
                    ) : (
                      ''
                    )}
                  </p>

                  <hr />

                  <FactsBox>
                    <h3 name="how-it-works">How it works</h3>
                    <ul>
                      <li>
                        &#9673; A duotone is a color effect where two colors are mapped according to
                        the underlining luminosity of the pixels. It has been made popular in recent
                        years by brands like Spotify. You can learn about how to create a duotone
                        effect from scratch in Photoshop{' '}
                        <Link to="/retouching/duotone/">in this post</Link>.
                      </li>

                      <li>
                        &#9673; On this page, you can upload a Jpeg image and preview different
                        duotone color combinations.
                      </li>

                      <li>
                        &#9673; To get started, download the{' '}
                        <a
                          href="https://purple11.s3.amazonaws.com/actions/purple11-duotones.zip"
                          download
                        >
                          free set of Photoshop actions
                        </a>
                        . Unzip the file and double click on the action file to install it, or go in
                        Photoshop into the action panel's menu and choose <em>Load Actions...</em>
                      </li>

                      <li>
                        &#9673; Once you like a particular duotone combination, you can either
                        download the image directly{' '}
                        <strong>(only available in Chrome and Firefox for the moment)</strong>, or
                        play the action with the corresponding duotone number (e.g.: Duotone #4) in
                        Photoshop.
                      </li>
                      <li>
                        &#9673; Once you've applied the action, feel free to tweak the colors or
                        strength of the effect to your likings.
                      </li>
                    </ul>
                  </FactsBox>
                  <hr />
                
                </div>
              </PostFullContent>
            </article>
            <MoreGoodies slug="duotone-generator" />
          </main>
          <BackToTop />
          <Footer />
        </Wrapper>

        <canvas ref={this.canvasRef} style={{ display: 'none' }} />
        <svg version="1.1" width="0" height="0">
          {/* Color stops: #00007D, #F60065 */}
          <filter id="filter-1" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />

            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 0.96" />
              <feFuncG type="table" tableValues="0 0" />
              <feFuncB type="table" tableValues="0.49 0.4" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Color stops: #181861, #00ff7f */}
          <filter id="filter-2" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.09 0" />
              <feFuncG type="table" tableValues="0.09 1" />
              <feFuncB type="table" tableValues="0.38 0.5" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #BE4800, #FFE400 */}
          <filter id="filter-3" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.75 1" />
              <feFuncG type="table" tableValues="0.28 0.89" />
              <feFuncB type="table" tableValues="0 0" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #551E73, #FF55D4 */}
          <filter id="filter-4" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.33 1" />
              <feFuncG type="table" tableValues="0.12 0.33" />
              <feFuncB type="table" tableValues="0.45 0.83" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #000654, #EB074A */}
          <filter id="filter-5" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 0.92" />
              <feFuncG type="table" tableValues="0.02 0.03" />
              <feFuncB type="table" tableValues="0.33 0.29" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #045451, #EBE105 */}
          <filter id="filter-6" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.02 0.92" />
              <feFuncG type="table" tableValues="0.33 0.88" />
              <feFuncB type="table" tableValues="0.32 0.02" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #400A0A, #FF2A2A */}
          <filter id="filter-7" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.25 1" />
              <feFuncG type="table" tableValues="0.04 0.16" />
              <feFuncB type="table" tableValues="0.04 0.16" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #0D0A66, #FF5B00 */}
          <filter id="filter-8" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.05 1" />
              <feFuncG type="table" tableValues="0.04 0.36" />
              <feFuncB type="table" tableValues="0.4 0" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #40063C, #FFCC00 */}
          <filter id="filter-9" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.25 1" />
              <feFuncG type="table" tableValues="0.02 0.8" />
              <feFuncB type="table" tableValues="0.24 0" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #CC2F86, #FFE5BF */}
          <filter id="filter-10" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.8 1" />
              <feFuncG type="table" tableValues="0.18 0.9" />
              <feFuncB type="table" tableValues="0.53 0.75" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #551E73, #FF3069 */}
          <filter id="filter-11" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.33 1" />
              <feFuncG type="table" tableValues="0.12 0.19" />
              <feFuncB type="table" tableValues="0.45 0.41" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #7A6602, #FCF3C5 */}
          <filter id="filter-12" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.48 0.99" />
              <feFuncG type="table" tableValues="0.4 0.95" />
              <feFuncB type="table" tableValues="0.01 0.77" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #100E7A, #FCF3C5 */}
          <filter id="filter-13" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.06 0.99" />
              <feFuncG type="table" tableValues="0.05 0.95" />
              <feFuncB type="table" tableValues="0.48 0.77" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #02233B, #69C0FF */}
          <filter id="filter-14" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.01 0.41" />
              <feFuncG type="table" tableValues="0.14 0.75" />
              <feFuncB type="table" tableValues="0.23 1" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #F0266D, #F1E66D */}
          <filter id="filter-15" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.94 0.95" />
              <feFuncG type="table" tableValues="0.15 0.9" />
              <feFuncB type="table" tableValues="0.43 0.43" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* color stops: #7B0AA3, #43DE9B */}
          <filter id="filter-16" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.48 0.26" />
              <feFuncG type="table" tableValues="0.04 0.87" />
              <feFuncB type="table" tableValues="0.64 0.61" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>
        </svg>
      </IndexLayout>
    );
  }
}

export default DuotoneGenerator;
